import React from 'react';
import { WeekGame } from '../../../../user/model/interfaces';
import DataTable from '../../../../../ui/components/dataTable';
import weekgameColumns from './weekgameColumns';
import styles from './weekgames.module.scss';
import { t } from '@base/utils/helpers';

export default function Weekgames(props: { weekgames?: WeekGame[] }) {
  return props.weekgames ? (
    <div>
      <h3>{t('last_games')}</h3>
      <div className={styles.table}>
        <DataTable<WeekGame> columns={weekgameColumns} data={props.weekgames} />
      </div>
    </div>
  ) : null;
}
